module.exports = __webpack_public_path__ + "static/media/samuel_nicolle_5.93c4d926.jpg";